// Every SPA deploy — production at money.bigg.city and Pages previews at
// *.money-webs.pages.dev — calls the production API. There is no preview
// API; previews exist only for visual UI inspection. Real API testing
// happens against production after merge to main (see CLAUDE.md "Deploy
// loop"). VITE_API_BASE_URL stays as a fallback for unknown hosts.

export function getApiBase(): string {
  const override = import.meta.env.VITE_API_BASE_URL;
  if (override) return override;
  return "https://api.money.bigg.city";
}
